module.exports = __webpack_public_path__ + "img/Detail-lan.f8445baa.png";